export default {
    value: 0,
};

